import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import InterTrade from "../../assets/InternationTrade.jpg";

const InternationalTrade = () => {
  return (
    <div>
      <Helmet>
        <title>International Trade Compliance | Trans World Shipping</title>
        <meta
          name="description"
          content="Explore our comprehensive international trade services with Trans World Shipping."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/trade-compliance"
        />
      </Helmet>

      <TheInternationalTrade>
        <div className="trade-hero">
          <img src={InterTrade} alt="International Trade Compliance" />
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>International Trade Compliance</h1>
            <p>
              Ensuring your goods enter the U.S. in full compliance with all
              laws and regulations
            </p>
          </div>
        </div>

        <div className="trade-container">
          <div className="definition-section">
            <p>
              Trade compliance is the process by which goods enter the United
              States in conformance with all U.S. laws and regulations.
            </p>
          </div>

          <div className="customs-section">
            <p>
              It is the goal of the Customs Service to maximize trade compliance
              while facilitating the importation of legitimate cargo.
            </p>
          </div>

          <div className="duty-section">
            <p>
              As your partner in the international shipping process, it is our
              duty to assist you in every way possible to ensure that trade
              compliance is handled effectively, avoiding costly delays so that
              your products arrive safely and securely.
            </p>
          </div>

          <div className="partnership-section">
            <p>
              Trans World Shipping works with brokers, integrated carriers and
              others to manage international shipments efficiently. Through our
              relationships, automation processes and streamlined approach, we
              ensure that your import-export operations run smoothly, and that
              compliance with the laws are followed.
            </p>
          </div>

          <div className="benefits-section">
            <p>
              With our help, you'll avoid costly border delays as well as fines
              and penalties. Trade legally and cost-effectively.
            </p>
          </div>

          <div className="process-section">
            <p>
              From pre-Customs to post-Customs, we provide an efficient method
              for handling the entire shipping and import function for your
              organization.
            </p>
          </div>

          <div className="agreements-section">
            <p>
              We also understand trade agreements including C-TPAT, CSI, Duty
              Drawback and others.
            </p>
          </div>

          <div className="conclusion-section">
            <p>
              You can depend on Trans World Shipping for efficient and
              cost-effective solutions for your international transportation
              needs. We allow your company to move goods across international
              borders without delays, fines or loss of export privileges.
            </p>
          </div>
        </div>
      </TheInternationalTrade>
    </div>
  );
};

const TheInternationalTrade = styled.div`
  width: 100%;
  background: #ffffff;

  .trade-hero {
    position: relative;
    width: 100%;
    height: 45vh;
    min-height: 350px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(11, 30, 51, 0.85) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 2.8rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.1rem;
        opacity: 0.9;
      }
    }
  }

  .trade-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .definition-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;

    p {
      color: white;
      font-size: 1.1rem;
      line-height: 1.7;
      font-weight: 500;
    }
  }

  .customs-section,
  .duty-section,
  .partnership-section,
  .process-section,
  .agreements-section {
    background: #f8f9fa;
    padding: 1.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.7;
    }
  }

  .benefits-section {
    background: #f8f9fa;
    padding: 1.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;
    border: 1px solid #d4af37;

    p {
      font-size: 1rem;
      color: #d4af37;
      line-height: 1.7;
      font-weight: 600;
    }
  }

  .conclusion-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2rem;
    border-radius: 12px;
    text-align: center;

    p {
      color: white;
      font-size: 1.05rem;
      line-height: 1.7;
    }
  }

  @media screen and (max-width: 1024px) {
    .trade-hero .hero-content h1 {
      font-size: 2.2rem;
    }
  }

  @media screen and (max-width: 900px) {
    .trade-hero {
      height: 40vh;
      min-height: 300px;

      .hero-content h1 {
        font-size: 2rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .trade-container {
      padding: 3rem 1.5rem;
    }
  }

  @media screen and (max-width: 768px) {
    .trade-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 1.6rem;
      }
    }

    .trade-container {
      padding: 2rem 1rem;
    }

    .definition-section p,
    .customs-section p,
    .duty-section p,
    .partnership-section p,
    .benefits-section p,
    .process-section p,
    .agreements-section p,
    .conclusion-section p {
      font-size: 0.95rem;
    }
  }

  @media screen and (max-width: 600px) {
    .trade-hero .hero-content h1 {
      font-size: 1.4rem;
    }

    .trade-hero .hero-content p {
      font-size: 0.9rem;
    }
  }

  @media screen and (max-width: 480px) {
    .trade-hero .hero-content h1 {
      font-size: 1.2rem;
    }

    .definition-section,
    .customs-section,
    .duty-section,
    .partnership-section,
    .benefits-section,
    .process-section,
    .agreements-section,
    .conclusion-section {
      padding: 1rem;
    }
  }
`;

export default InternationalTrade;
